export enum AssessmentCreationSteps {
    PersonSelection = 1,
    AssessmentTypeChoice = 2,
    InvitationEditing = 3
}
